<template>
  <div class="wrapper">
    <parallax
      class="section page-header header-filter"
      :style="headerStyle"
    ></parallax>
    <div class="main main-raised">
      <div class="section profile-content">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item md-size-50 mx-auto">
              <div class="profile">
                <div class="name">
                  <h3 class="title">Fiche d'inscription téléchargeable</h3>
                </div>
              </div>
            </div>
          </div>
          <div class="description text-center">
            <p></p>
          </div>
          <formulaire class="bas" @info="retourData" />
          <viewPdf class="bas" :flow="sendInfo" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import viewPdf from "./myComponents/viewPdf";
import formulaire from "@/views/myComponents/telechargeable/formulaire";

export default {
  components: {
    viewPdf,
    formulaire
  },
  bodyClass: "profile-page",

  data() {
    return {
      allInfo: null
    };
  },

  props: {
    header: {
      type: String,
      default: require("@/assets/img/trip.jpg")
    }
  },

  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
      };
    },

    sendInfo() {
      return this.allInfo;
    }
  },

  methods: {
    retourData(a) {
      this.allInfo = a;
      console.log(a);
    }
  }
};
</script>

<style lang="scss" scoped>
.section {
  padding: 0;
}

.profile-tabs::v-deep {
  .md-card-tabs .md-list {
    justify-content: center;
  }

  [class*="tab-pane-"] {
    margin-top: 3.213rem;
    padding-bottom: 50px;

    img {
      margin-bottom: 2.142rem;
    }
  }
}
.profile {
  margin-top: 7rem;
}
.bas {
  margin-bottom: 5rem;
}
</style>
